import './CarInfoCard.css'
import {Typography} from "@material-ui/core";
import CarCard from "../carcard/CarCard";
import React, {ReactElement} from "react";

interface ICaseInfoProps {
    title: string,
    child: ReactElement
}

export default function CaseInfoCard(props: ICaseInfoProps) {
    return <div className="CaseInfoCard">
        <div className="Case_info_card_title">{props.title}</div>
        {props.child}
    </div>
}